import React, { useState } from "react";
import Button from "./Button";
import logo_1 from "../Assets/Images/logo-black.svg";
import "../Components/text.css";
import { NavLink } from "react-router-dom";

function Header() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const openCalendly = () => {
    console.log("Button clicked");
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: "https://calendly.com/watersprint-info/30min?hide_gdpr_banner=1",
      });
    } else {
      console.error("Calendly script not loaded. Retrying...");
      setTimeout(() => {
        if (window.Calendly) {
          window.Calendly.initPopupWidget({
            url: "https://calendly.com/watersprint-info/30min?hide_gdpr_banner=1",
          });
        } else {
          console.error("Calendly still not loaded. Check script inclusion.");
          alert("Unable to load Calendly. Please try again later or check your internet connection.");
        }
      }, 1000);
    }
  };

  return (
    <>
      <style>
        {`
          .maintext {
            color: #000;
            text-decoration: none;
            font-size: 14px;
            font-weight: 500;
            transition: all 0.3s ease;
            position: relative;
            padding: 8px 0;
          }

          .maintext:hover {
            color: #14B88F;
          }

          .dropdown-menu {
            position: absolute;
            top: calc(100% + 10px);
            left: 50%;
            transform: translateX(-50%);
            background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
            border-radius: 12px;
            border: 1px solid rgba(0, 0, 0, 0.06);
            z-index: 1000;
            min-width: 180px;
            padding: 8px;
            opacity: 0;
            visibility: hidden;
            transform: translateX(-50%) translateY(-10px);
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          }

          .dropdown-menu.open {
            opacity: 1;
            visibility: visible;
            transform: translateX(-50%) translateY(0);
          }

          .dropdown-menu::before {
            content: '';
            position: absolute;
            top: -6px;
            left: 50%;
            transform: translateX(-50%) rotate(45deg);
            width: 12px;
            height: 12px;
            background: white;
            border-left: 1px solid rgba(0, 0, 0, 0.06);
            border-top: 1px solid rgba(0, 0, 0, 0.06);
          }

          .dropdown-item {
            display: flex;
            align-items: center;
            padding: 12px 16px;
            color: #1e293b;
            text-decoration: none;
            font-size: 14px;
            font-weight: 500;
            border-radius: 8px;
            transition: all 0.2s ease;
            position: relative;
            overflow: hidden;
          }

          .dropdown-item::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 3px;
            height: 100%;
            background: #14B88F;
            transform: scaleY(0);
            transition: transform 0.2s ease;
          }

          .dropdown-item:hover {
            background: rgba(20, 184, 143, 0.08);
            color: #14B88F;
            transform: translateX(4px);
          }

          .dropdown-item:hover::before {
            transform: scaleY(1);
          }

          .services-link {
            display: flex;
            align-items: center;
            gap: 4px;
          }

          .arrow-icon {
            display: inline-block;
            transition: transform 0.3s ease;
            font-size: 12px;
          }

          .services-link:hover .arrow-icon,
          .dropdown-open .arrow-icon {
            transform: rotate(180deg);
          }

          /* Fixed Header Background */
          .fixed-header {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            background: white;
            z-index: 999;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;
          }

          /* Body padding to avoid content jump */
          body {
            padding-top: 60px; /* Adjust based on header height */
          }
        `}
      </style>

      {/* Fixed Header */}
      <div
        className="fixed-header"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: "5px 20px",
          borderBottom: "0.1px solid #E5E8EB",
          justifyContent: "space-between",
          height: "60px",
          boxSizing: "border-box",
        }}
      >
        {/* Logo Section */}
        <div>
          <NavLink
            to="/"
            style={{ background: "none", border: "none", display: "inline-block" }}
          >
            <img src={logo_1} alt="Company Logo"/>
          </NavLink>
        </div>

        {/* Navigation + Button */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            flexDirection: "row",
            gap: "20px",
            fontSize: "14px",
          }}
        >
          {/* Services Dropdown */}
          <div
            style={{ position: "relative" }}
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
          >
            <NavLink
              className={`maintext services-link ${isDropdownOpen ? 'dropdown-open' : ''}`}
              aria-haspopup="true"
              aria-expanded={isDropdownOpen}
            >
              Services
              <span className="arrow-icon">▼</span>
            </NavLink>
            <div className={`dropdown-menu ${isDropdownOpen ? 'open' : ''}`}>
              <NavLink
                to="/Services/Climate"
                className="dropdown-item"
                onClick={() => setIsDropdownOpen(false)}
              >
                Climate & Water Intelligence
              </NavLink>
              <NavLink
                to="/Services/IT"
                className="dropdown-item"
                onClick={() => setIsDropdownOpen(false)}
              >
                IT & Data Science Solutions
              </NavLink>
            </div>
          </div>

          <NavLink className="maintext" to="/Projects">
            Projects
          </NavLink>
          <NavLink className="maintext" to="/OurProduct">
            Products
          </NavLink>
          <NavLink className="maintext" to="/Aboutus">
            About
          </NavLink>
          <NavLink className="maintext" to="/Contactus">
            Contact
          </NavLink>

          <div style={{ color: 'white', height: "60px", display: "flex", alignItems: "center" }}>
            <Button buttonname="Book a consultation" onClick={openCalendly} />
          </div>
        </div>
      </div>

      {/* Optional: Add padding to body or main content */}
      {/* Agar aap App.js ya index.js mein body style kar sakte hain to yeh add karo */}
      {/* Ya phir main content ke parent div ko margin-top do */}
    </>
  );
}

export default Header;